import { FC } from 'react';
import { DataCategory } from '../../subheader-category-items/types';
import { CatList } from '@blocks-react/components/List';
import { CatListItem } from '@blocks-react/components/ListItem';
import styles from '../../subheader-category-items/style.module.scss';
import { MAIN_NAV_TRACK } from '../../../../../constants/analyticsConstants';

interface MobileBuyingOptionProps {
  label: string;
  buyingOptions: DataCategory[];
}

export const SubheaderMobileBuyingOptions: FC<MobileBuyingOptionProps> = ({
  label,
  buyingOptions,
}) => {
  return (
    <CatListItem
      className={styles['c-top-nav__list-item']}
      data-track-event={MAIN_NAV_TRACK.EVENT}
      data-track-attr-nltext={label}
      data-track-attr-context={MAIN_NAV_TRACK.TOP_SUBMENU_CONTEXT}
    >
      {label}
      <CatList slot="items">
        {buyingOptions.map(({ data }) =>
          data.map(({ name, seoURL }) => (
            <CatListItem
              key={name}
              href={seoURL}
              styleModifier={'cat-u-padding-none'}
              data-testid="category-list-item"
              data-track-event={MAIN_NAV_TRACK.EVENT}
              data-track-attr-nltext={name}
              data-track-attr-context={MAIN_NAV_TRACK.TOP_SUBMENU_CONTEXT}
            >
              {name}
            </CatListItem>
          ))
        )}
      </CatList>
    </CatListItem>
  );
};
